import ApiClient from './ApiClient';

const engineerThreadsClient = new ApiClient('engineer_threads', {
  accountScoped: true,
});

const EngineerThreadsAPI = {
  getAll() {
    return engineerThreadsClient.get();
  },

  getByConversationId(
    conversationId,
    { includeMessages = false, signal = null } = {}
  ) {
    const params = includeMessages ? '?include_messages=true' : '';
    return engineerThreadsClient.get(
      `by_conversation/${conversationId}${params}`,
      { signal }
    );
  },

  getFreeThread({ includeMessages = false, signal = null } = {}) {
    const params = includeMessages ? '?include_messages=true' : '';
    return engineerThreadsClient.get(`free_thread${params}`, { signal });
  },

  getMessages(threadId, { signal = null } = {}) {
    return engineerThreadsClient.get(`${threadId}/thread_messages`, {
      signal,
    });
  },

  getOlderMessages(threadId, { beforeId, perPage = 50 } = {}) {
    const params = new URLSearchParams();
    if (beforeId) params.set('before_id', beforeId);
    params.set('per_page', perPage);
    return engineerThreadsClient.get(
      `${threadId}/thread_messages?${params.toString()}`
    );
  },

  create(data) {
    if (data.conversation_id) {
      data.thread_type = 'conversation';
    }
    return engineerThreadsClient.create(data);
  },

  createFreeThread({ signal = null } = {}) {
    return engineerThreadsClient.create({ thread_type: 'free' }, { signal });
  },

  createConversationThread(conversationId) {
    return engineerThreadsClient.create({
      conversation_id: conversationId,
      thread_type: 'conversation',
    });
  },

  update(threadId, data) {
    return engineerThreadsClient.update(threadId, data);
  },

  createMessage(threadId, data) {
    return engineerThreadsClient.post(`${threadId}/thread_messages`, data);
  },

  // Edit-e-reinvia: cancella il messaggio indicato e tutti i successivi.
  // Accetta l'id DB oppure il client_request_id (messaggi appena inviati,
  // per cui il FE non ha ancora l'id).
  rewindToMessage(threadId, { messageId, clientRequestId } = {}) {
    const params = new URLSearchParams();
    if (messageId) params.set('message_id', messageId);
    else if (clientRequestId) params.set('client_request_id', clientRequestId);
    return engineerThreadsClient.delete(
      `${threadId}/thread_messages/rewind?${params.toString()}`
    );
  },
};

export default EngineerThreadsAPI;
